var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerificationPageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#ECF1F7"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28050_41213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 28,
    width: 43,
    height: 43
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8774 28.7041H71.7925V70.6191H29.8774V28.7041Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28050_41213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2588 55.8411V54.8625C45.2588 53.3298 47.5337 51.6345 48.7065 50.6068H48.7159C49.0035 50.3548 49.1547 50.0044 49.1547 49.654C49.1547 49.3036 49.0035 48.9532 48.7159 48.7011C47.543 47.6734 45.2681 45.9782 45.2681 44.4455V43.467C45.2681 42.7696 45.8295 42.2043 46.5219 42.2043H54.9845C55.6768 42.2043 56.2381 42.7696 56.2381 43.467V44.4455C56.2381 45.9782 53.9633 47.6734 52.7904 48.7011C52.5028 48.9532 52.3517 49.3036 52.3517 49.654C52.3517 50.0044 52.5028 50.3548 52.7904 50.6068C53.9633 51.6345 56.2381 53.3298 56.2381 54.8625V55.8411C56.2381 56.5385 55.6768 57.1038 54.9845 57.1038H50.7531H46.9607H46.5219C45.8295 57.1038 45.2681 56.5385 45.2681 55.8411",
    stroke: "#1E247E",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.835 30.3402C61.5053 30.3402 70.1552 38.9902 70.1552 49.6604",
    stroke: "#DA867D",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3291 41.4744C36.4106 34.8966 43.0903 30.3407 50.8342 30.3407",
    stroke: "#DA867D",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8997 42.1282H33.9701C32.6138 42.1282 31.5142 41.0286 31.5142 39.6722V35.7427",
    stroke: "#1E247E",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7525 68.9753C40.0823 68.9753 31.5142 60.3254 31.5142 49.6551",
    stroke: "#F0C330",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.258 57.8417C65.1765 64.4194 58.4968 68.9753 50.7529 68.9753",
    stroke: "#F0C330",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 57.1903H67.6989C69.0552 57.1903 70.1549 58.2899 70.1549 59.6462V63.4939",
    stroke: "#1E247E",
    strokeWidth: 2.48385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationPageIcon);
export default __webpack_public_path__ + "static/media/VerificationPageIcon.f540cbd3cbcbb982f41cd3f990aec624.svg";
export { ForwardRef as ReactComponent };